var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"checkbox-component",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"checkbox",class:{'checked': _vm.iChecked, 'disabled': _vm.disabled, 'disabled-checked': _vm.checked && _vm.disabled}}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"extra"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }